// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerItem_container__jRzlM"};